import styled from 'styled-components';

const InfoWrap = styled.section(
    props => `
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;
  
      @media only screen and (min-width:320px) and (max-width: 767px){
          width:100%;
      }
      @media only screen and (min-width:768px) and (max-width: 1024px){
          width:100%;
      }
    `,
);

export const InfoStripWrapper = styled(InfoWrap)(
props => `
    width: 100%;
    background-color: ${props.theme.colors.white.base};
    overflow: hidden;
    flex-direction: column;
    margin-top: ${props.theme.spacing.large.l40};
`,
);

export const InfoBlockWrapper = styled(InfoWrap)(
props => `
    width:50%;
    flex-direction: column;
`,
);

export const InfoBlockInner = styled.div(
props => `
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l45} ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l60};
    flex-direction: column;
    margin-bottom: ${props.theme.spacing.base};

    @media only screen and (min-width:320px) and (max-width: 767px){
    padding: 0;
    overflow: auto;
    ::-webkit-scrollbar {
        display: none;
    }
    }

    @media only screen and (min-width:768px) and (max-width: 1024px){
    padding: 0;
    overflow: auto;
    ::-webkit-scrollbar {
        display: none;
    }
    }
    @media only screen and (min-width:1025px) and (max-width: 1300px){
    width: 98%;
    margin: 0 auto;
    padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.nospacing} ${props.theme.spacing.nospacing};
    }
`,
);

export const HeaderTextWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin: ${props.theme.spacing.large.l20} 0 ${props.theme.spacing.base};
    `
)

export const TestimonyHeadText = styled.h2(
    props => `
        font-size: ${props.theme.font.large.font40};
        color: ${props.theme.colors.black.base1};
        font-weight: ${props.theme.font.fontWeight.black};
        @media only screen and (min-width:320px) and (max-width: 767px){
            font-size: ${props.theme.font.large.font18};
        }
    `
)

export const TestimonySubText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.grey.dark3};
        @media only screen and (min-width:320px) and (max-width: 767px){
            font-size: ${props.theme.font.large.font16};
        }
    `
)

export const MoreInfoList = styled.ul(
    props => `
      width:100%;
      display: flex;
  
      li{
        display: flex;
        padding: 1rem;
        width: 33%;
      }
  
      @media only screen and (min-width:320px) and (max-width: 767px){
        width:150rem;
        flex-direction: row;
        padding: 1rem;
  
        li{
          width:30rem;
          margin-right: ${props.theme.spacing.base};
          padding: 1rem 0;
        }
      }
  
      @media only screen and (min-width:768px) and (max-width: 1024px){
        width:150rem;
        flex-direction: row;
        padding: 1rem;
  
        li{
          width:30rem;
          margin-right: ${props.theme.spacing.base};
          padding: 1rem 0;
        }
      }
  
      @media only screen and (min-width:1025px) and (max-width: 1300px){
        width:100%;
        flex-direction: row;
  
        li{
          width:100%;
          margin-right: ${props.theme.spacing.base};
          padding: ${props.theme.spacing.large.base} ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
          display: flex;
          align-items: center;
          flex-direction: row;
        }
      }
      `,
);

export const ArrowIconRightWrapper = styled.div(
  props => `
    margin: auto 0;
    cursor: pointer;
    position: absolute;
    right: 9rem ;
    top:2.3rem;
    height:4rem;
    width:4rem;
    background-color: ${props.theme.colors.white.base};
    border-radius: 50%;
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.25);
    align-items: center;
    justify-content: center;
    display: flex;
    @media only screen and (min-width:320px) and (max-width: 767px){
        display: none;
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
        display: none;
    }
  `
);


export const ArrowIconLeftWrapper = styled.div(
  props => `
    margin: auto 0;
    cursor: pointer;
    position: absolute;
    left: 9rem ;
    top:2.3rem;
    height:4rem;
    width:4rem;
    background-color: ${props.theme.colors.white.base};
    border-radius: 50%;
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.25);
    align-items: center;
    justify-content: center;
    display: flex;
    @media only screen and (min-width:320px) and (max-width: 767px){
        display: none;
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
        display: none;
    }
  `
);

export const MainContentWrap = styled.div(
    props =>   `
        width:100%;
        display: flex;
    `
);

export const ContentOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.base};
    `
);

export const ContentInfoWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        
    `
);

export const UserImgWrap = styled.div(
    props => `
        width:5.2rem;
        height: 5.2rem;
        border-radius: 1rem;
        background-color: ${props.theme.colors.grey.lighte5};
        border:1px solid ${props.theme.colors.grey.lighte7};

        img{
            width:5.2rem;
            height: 5.2rem;
            border-radius: 1rem;
        }
    `
);

export const UserInfoWrap = styled.div(
    props => `
        display: flex;
        flex-direction: column;
    `
);

export const UserNameText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font24};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};

        @media only screen and (min-width:320px) and (max-width: 767px){
            font-size: ${props.theme.font.large.font14};
        }
    `
);

export const UserAgencyNameText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base};
    `
);

export const ContentMainTextWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l20} 0;
    `
);

export const ContentMainText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.base};
        lin-height: 1.3;
    `
)